export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  GERAR_ATA: '/atas/gerar',
  NOT_FOUND: '*',
};

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  THEME: 'theme',
};

export const QUERY_KEYS = {
  HEALTH: ['health'],
  ME: ['auth', 'me'],
};
